<template>
  <div class="min-h-screen flex flex-col font-Almarai ">
    <!-- Main Container -->
    <div class="flex-1 flex flex-col items-center p-0 m-0">
      <!-- Hero Image Section with Logo and Language Toggle -->
      <div class="w-full md:max-w-4xl max-w-md mb-8 relative">
        <!-- Logo in top middle of slider -->
        <div class="absolute top-6 left-1/2 transform -translate-x-1/2 z-50">
          <img
            src="@/assets/logo-1.webp"
            alt="Nasna TV Logo"
            class="w-24 h-auto"
          />
        </div>

        <!-- Language Toggle in top right of slider -->
        <div class="absolute top-6 right-6 z-50">
          <button
            @click="toggleLanguage"
            class="bg-transparent border border-white text-white px-3 py-1 rounded-md text-sm hover:bg-white hover:text-black transition-colors"
          >
            {{ currentLanguage === "ar" ? "English" : "العربية" }}
          </button>
        </div>

        <div class="relative">
          <!-- Carousel component -->
          <auth-carsouel />
        </div>
      </div>

      <!-- Main Title -->
      <div class="px-4 leading-[1.4] ">
        <h1
          class="text-white text-[1rem] text-center mb-2 font-Almarai"
          v-if="currentLanguage === 'ar'"
        >
          أنت على وشك الإشتراك في خدمة المحتوى
        </h1>
        <h1 class="text-white text-[1rem] text-center mb-2 font-sans" v-else>
          You are about to subscribe to the content service
        </h1>

        <!-- Brand Name -->
        <div class="text-center mb-2">
          <h2 class="text-[1.5rem] font-bold text-[#CB34C5]">
            {{ translations.brandName[currentLanguage] }}
          </h2>
        </div>

        <!-- Subtitle -->
        <p
          class="text-gray-300 text-center mb-8 font-Almarai"
          v-if="currentLanguage === 'ar'"
        >
          أدخل رقم الجوال للمتابعة
        </p>
        <p class="text-gray-300 text-center mb-8 font-sans" v-else>
          Enter mobile number to continue
        </p>
      </div>

      <!-- Phone Input Form -->
      <div class="w-full max-w-sm mb-2 px-4">
        <div class="relative">
          <input
            v-model="phoneNumber"
            :placeholder="translations.phonePlaceholder[currentLanguage]"
            type="tel"
            class="w-full px-4 py-3 bg-white/90 backdrop-blur-sm text-gray-800 rounded-lg border-none outline-none focus:ring-2 focus:ring-purple-500 text-center text-lg font-medium placeholder-gray-500 transition-transform duration-500 ease-in-out"
            :class="{
              'animate-pulse-scale': phoneNumber.length === 0,
              'scale-100': phoneNumber.length > 0
            }"
            :dir="currentLanguage === 'ar' ? 'rtl' : 'ltr'"
            maxlength="12"
          />
        </div>
  <!-- Subscribe Button -->
      <button
        @click="handleSubscribe"
        :disabled="!isPhoneValid.valid"
        class="w-full max-w-sm text-white font-bold py-3 px-4 pb-4 rounded-lg text-lg my-3 transition-transform duration-500 ease-in-out"
        :class="{
          'animate-pulse': isSubmitting,
          'animate-pulse-scale': phoneNumber.length > 0 && !isPhoneComplete,
          'scale-100': isPhoneComplete || phoneNumber.length === 0
        }"
        style="background: linear-gradient(90deg, #cb34c5 0%, #412955 100%)"
      >
        {{
          isSubmitting
            ? translations.subscribing[currentLanguage]
            : translations.subscribe[currentLanguage]
        }}
      </button>

      </div>

      

      <!-- Terms and Conditions -->
      <div class="mt-2 text-center max-w-sm px-4">
        <p
          class="text-xs text-gray-400 leading-relaxed font-Almarai"
          v-if="currentLanguage === 'ar'"
        >
          *هذه الخدمة متوفرة لعملاء شركة الاتصالات السعودية مقابل 2 ريال لعملاء
          مسبق الدفع (تجدد يومياً) و بمقابل 69 ريال لعملاء المفوتر تتجدد شهرياً
          (شامل قيمة الضريبة المضافة) ولإلغاء الاشتراك الرجاء ارسال "غ 1" الى
          802621. تم تحصيل مبلغ الضريبة المضافة لعملاء مسبق الدفع عند عملية شحن
          الرصيد
        </p>
        <p class="text-xs text-gray-400 leading-relaxed font-sans" v-else>
          *This service is available for Saudi Telecom Company customers for 2
          SAR for prepaid customers (renewed daily) and 69 SAR for postpaid
          customers renewed monthly (including VAT). To cancel the subscription,
          please send "غ 1" to 802621. VAT has been collected for prepaid
          customers during the balance recharge process.
        </p>
      </div>
      <!-- Mobily text -->
      <div class="mt-4 text-center max-w-sm px-4">
        <p
          class="text-xs text-gray-400 leading-relaxed font-Almarai"
          v-if="currentLanguage === 'ar'"
        >
          *هذه الخدمة متاحة لعملاء موبايلي مقابل 5.75 ريال، يتم تجديدها
          أسبوعياً. (شامل قيمة الضريبة المضافة) لالغاء اشتراكك الرجاء
          <a
            href="http://infomob.digitalcg.net/"
            style="color: #cb34c5; text-decoration: underline"
            >زيارة الموقع</a
          >
        </p>
        <p class="text-xs text-gray-400 leading-relaxed font-sans" v-else>
          *This service is available for Mobily customers for 5.75 SAR, renewed
          weekly. (Including VAT) To cancel your subscription, please
          <a
            href="http://infomob.digitalcg.net/"
            style="color: #cb34c5; text-decoration: underline"
            >visit the website</a
          >.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import AuthCarsouel from "@/components/shared/AuthCarsouel.vue";
import { useAuthStore } from "@/stores/auth";
import { mapActions } from "pinia";
import { validateSaudiPhone } from "@/utils/validation";
export const AF = "AntiFrauduniqid"; // Anti-Fraud Uniq ID
import { useToast } from "vue-toastification";
import {getOtpErrorMessage} from "@/errorCodes"
export default {
  name: "KsaSubscriptions",
  components: {
    AuthCarsouel,
  },
  data() {
    return {
      currentLanguage: "ar", // Default to Arabic
      phoneNumber: "",
      isSubmitting: false,
      showTerms: false,
      subscriptionPrice: "5.75",
      subscriptionPeriod: "أسبوع", // week in Arabic
      cancelCode: "80261",
      termsText: "شروط الخدمة تطبق",
      termsTextEn: "Terms and conditions apply",
      translations: {
        heroImageAlt: {
          ar: "ناسنا تي في",
          en: "Nasna TV",
        },
        brandName: {
          ar: "Nasna TV ناسنا",
          en: "Nasna TV",
        },
        phonePlaceholder: {
          ar: "05XXXXXXXX",
          en: "05XXXXXXXX",
        },
        subscribe: {
          ar: "اشترك",
          en: "Subscribe",
        },
        subscribing: {
          ar: "جاري الاشتراك...",
          en: "Subscribing...",
        },
        viewTerms: {
          ar: "عرض الشروط والأحكام",
          en: "View Terms & Conditions",
        },
        termsTitle: {
          ar: "الشروط والأحكام",
          en: "Terms & Conditions",
        },
      },
      toast: useToast(),

    };
  },
  computed: {
    isPhoneValid() {
      const validation = validateSaudiPhone(this.phoneNumber);
      return validation;
    },
    phoneProvider() {
      const validation = validateSaudiPhone(this.phoneNumber);
      return validation.provider;
    },
    isPhoneComplete() {
      return this.phoneNumber.length >= 10;
    },
  },
  methods: {
    ...mapActions(useAuthStore, ["callAntifraudAPI", "callOtpAPI"]),
    toggleLanguage() {
      this.currentLanguage = this.currentLanguage === "ar" ? "en" : "ar";
    },
    async handleSubscribe() {
      if (!this.isPhoneValid.valid) {
        this.toast.error("رقم الهاتف غير صحيح");
        return;
      }
     
      try {
        this.isSubmitting = true;
        await this.callOtpAPI(this.isPhoneValid.phoneNumber, "daily").then(response=>{
           const data = response.data;
            // make the operator to lower case 
            const operator = data.operator ? data.operator.toLowerCase() : null;
            if(data.success && operator === 'stc'){
              window.location.href = data.url;
            }else if(operator === 'mobily'){
              if(data.success){
              window.location.href = `https://mobily.nasna.tv/auth/verify-otp?msisdn=${this.isPhoneValid.phoneNumber}`;
              }else{

                const errorMessage = getOtpErrorMessage(data?.data?.Code, this.currentLanguage);
                this.toast.error(errorMessage || "حدث خطأ ما، حاول مرة أخرى");
                if(data.data?.Code === 10204){
                  this.isSubmitting = false;
                  setTimeout(() => {
                    window.location.href= "https://mobily.nasna.tv/auth/mobily/login"
                  }, 3000);
                }
                                  this.isSubmitting = false;

              }
            }else{
                this.toast.error("هذا الرقم غير مدعوم. تأكد من إدخال رقم من شبكة موبايلي أو STC.")
            }
        });
      } catch (error) {
        console.error("Subscription error:", error);
      } finally {
        this.isSubmitting = false;
      }
      this.isSubmitting = true;
    },

    async injectAntifraudScript(packageName) {
      // First, remove any existing antifraud scripts
      this.removeExistingAntifraudScripts();

      // Use a global flag to prevent multiple calls across component recreations
      if (!window.antifraudScriptProcessing) {
        window.antifraudScriptProcessing = true; // Set global flag immediately

        if (process.env.NODE_ENV === "development") {
          console.log(
            "Antifraud script injection started for package:",
            packageName
          );
        }
        try {
          console.log("Calling antifraud API for package:", packageName);
          const response = await this.callAntifraudAPI(packageName);

          // Check if response exists and has the expected structure
          if (!response) {
            throw new Error("API response is undefined");
          }

          if (!response.data) {
            throw new Error("API response.data is undefined");
          }

          if (response.data.success && response.data.data) {
            window.localStorage.setItem(AF, response.data.data.AntiFrauduniqid);

            // Dynamically add the script tag to the <head>
            const scriptTag = document.createElement("script");
            scriptTag.type = "text/javascript";
            scriptTag.text = response.data.data.script;
            scriptTag.setAttribute("data-id", `antifraud-${packageName}`);
            document.head.appendChild(scriptTag);

            // Manually trigger DCBprotect execution since DOMContentLoaded has already fired
            const ev = new Event("DCBProtectRun");
            document.dispatchEvent(ev);

            if (process.env.NODE_ENV === "development") {
              console.log(
                `antifraud script for ${packageName} injected successfully to head and manually triggered`
              );
            }
          } else {
            throw new Error("API returned success: false or missing data");
          }
        } catch (error) {
          console.error("Failed to inject antifraud script:", error);
          window.antifraudScriptProcessing = false; // Reset flag on error
        } finally {
          window.antifraudScriptProcessing = false; // Reset flag when done
        }
      } else {
        if (process.env.NODE_ENV === "development") {
          console.log("antifraud script processing is already in progress");
        }
      }
    },

    removeExistingAntifraudScripts() {
      // Remove all existing antifraud scripts
      const existingScripts = document.querySelectorAll(
        'script[data-id^="antifraud-"]'
      );
      existingScripts.forEach((script) => {
        if (process.env.NODE_ENV === "development") {
          console.log(
            "Removing existing antifraud script:",
            script.getAttribute("data-id")
          );
        }
        script.remove();
      });

      // Also remove any legacy antifraud scripts without package name
      const legacyScript = document.querySelector(
        'script[data-id="antifraud"]'
      );
      if (legacyScript) {
        if (process.env.NODE_ENV === "development") {
          console.log("Removing legacy antifraud script");
        }
        legacyScript.remove();
      }
    },
  },
  watch: {
    // Watch for phone number completion to trigger input animation
    isPhoneComplete(newVal) {
      if (newVal) {
        // When phone is complete, scale input back to normal
        this.inputAnimated = true;
        // After input scales down, scale button up
        setTimeout(() => {
          this.buttonAnimated = true;
        }, 500);
      } else {
        // When phone is incomplete, reset animations
        this.inputAnimated = false;
        this.buttonAnimated = false;
        this.buttonClicked = false;
      }
    },
    
    // Watch for language changes
    currentLanguage(newLang) {
      localStorage.setItem('nasna_language', newLang);
    },
    

  },
  mounted() {
    // Set language based on user preference or browser locale
    const savedLanguage = localStorage.getItem("nasna_language");
    if (savedLanguage) {
      this.currentLanguage = savedLanguage;
    }
  },
 
  beforeUnmount() {
    // Clean up all antifraud scripts when component is destroyed
    this.removeExistingAntifraudScripts();
    // Reset global flag
    window.antifraudScriptProcessing = false;
  },
  // For Vue 3 compatibility
  unmounted() {
    // Clean up all antifraud scripts when component is unmounted
    this.removeExistingAntifraudScripts();
    // Reset global flag
    window.antifraudScriptProcessing = false;
  },
  created() {
    this.injectAntifraudScript(this.isSelected);
  },
};
</script>

<style scoped>
/* Custom styles for Arabic font support */
.font-Almarai {
  font-family: "Almarai", "Arial", sans-serif;
}

/* Custom gradient background */
.bg-gradient-to-b {
  background: linear-gradient(to bottom, #1a1a1a 0%, #000000 100%);
}

/* Custom pulsing scale animation */
.animate-pulse-scale {
  animation: pulse-scale 1s ease-in-out infinite;
}

@keyframes pulse-scale {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

/* Phone input focus styles */
input:focus {
  box-shadow: 0 0 0 2px rgba(168, 85, 247, 0.5);
}

/* Button hover effects */
button:hover {
  transform: translateY(-1px);
}

/* Responsive text sizing */
@media (max-width: 640px) {
  .text-4xl {
    font-size: 2rem;
  }
}
</style>